import { render, staticRenderFns } from "./AttachDocument.vue?vue&type=template&id=2a3e82d6"
import script from "./AttachDocument.vue?vue&type=script&lang=js"
export * from "./AttachDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports